(() => {
  if (customElements.get('zayn-reveal')) return;

  class ZaynReveal extends HTMLElement {
    connectedCallback() {
      if (this.dataset.zaynRevealReady === 'true') return;
      this.dataset.zaynRevealReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.classList.add('is-motion-ready');

      if (reduceMotion || !('IntersectionObserver' in window)) {
        this.classList.add('is-active');
        return;
      }

      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;
          this.classList.add('is-active');
          this.observer.disconnect();
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.14 }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('zayn-reveal', ZaynReveal);
})();
